'use client';

import { useEffect } from 'react';

import redirects from '@/data/redirects.json';

/**
 * Client-side redirect when the current path is in the redirect map.
 * Ensures the browser URL updates to the canonical path even when the edge
 * returns 200 (e.g. cached) instead of 301. Kept in sync with CloudFront
 * redirects (same source: frontend/src/data/redirects.json).
 */
export function RedirectToCanonical() {
  useEffect(() => {
    const pathname = window.location.pathname;
    const withSlash = pathname.endsWith('/') ? pathname : `${pathname}/`;
    const withoutSlash = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

    const target =
      (redirects as Record<string, string>)[pathname] ??
      (redirects as Record<string, string>)[withSlash] ??
      (redirects as Record<string, string>)[withoutSlash];

    if (target) {
      const url = new URL(target, window.location.origin);
      window.location.replace(url.toString());
    }
  }, []);

  return null;
}
